export const patterns = {
  telephone: /^[\d+\- ]+$/,
  slug: /^[a-z0-9-]+$/,
  hex: {
    lowercase: /^[a-f0-9]+$/
  },
  base64: {
    urlSafe: /^[A-Za-z0-9_-]+$/
  },
} as const; 
